import { render, staticRenderFns } from "./certificateTypeConfigManager.vue?vue&type=template&id=33fde720"
import script from "./certificateTypeConfigManager.vue?vue&type=script&lang=js"
export * from "./certificateTypeConfigManager.vue?vue&type=script&lang=js"
import style0 from "./certificateTypeConfigManager.vue?vue&type=style&index=0&id=33fde720&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports